import { useMemo } from 'react'
import type { Brand } from './types'
import { getActiveBrand } from './registry'

/** Marca activa según el host actual. Estable durante toda la sesión. */
export function useBrand(): Brand {
  return useMemo(() => getActiveBrand(), [])
}
